import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, ButtonResponsiveWrapper, HsaIcon, useResponsive } from '@common-fe/common-fe';

import { Banner } from '@/modules/core/components/Dashboard/components/BannersList/Banner';
import { BannerStorageKey } from '@/modules/core/components/Dashboard/components/BannersList/bannersList.constants';
import useDismissBanner from '@/modules/core/components/Dashboard/components/BannersList/hooks/useDismissBanner';
import { ManageProfileTabs } from '@/modules/user/components/ManageProfile/manageProfile.types';
import useRedirectToManageProfileTab from '@/modules/user/components/ManageProfile/useRedirectToManageProfileTab';

const BeneficiaryBanner = () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const { handleDismissBanner } = useDismissBanner();

  const handleDismiss = useCallback(() => {
    handleDismissBanner(BannerStorageKey.BeneficiaryBanner);
  }, [handleDismissBanner]);

  const { handleOpenManageProfileTab } = useRedirectToManageProfileTab();

  return (
    <Banner
      title={t('Don’t Forget to Add Your HSA Beneficiaries')}
      description={t('Take a moment to designate your beneficiaries now.')}
      icon={<HsaIcon />}
      testId="BeneficiaryBanner"
    >
      <ButtonResponsiveWrapper isReversedMode margin={{ top: 'spacing24' }}>
        <AppButton
          testId="openManageProfileTab"
          onClick={() => handleOpenManageProfileTab(ManageProfileTabs.BENEFICIARIES)}
          width="180px"
          fill={isMobile}
        >
          {t('Add')}
        </AppButton>

        <AppButton
          testId="BeneficiaryBanner_dismiss-banner"
          buttonType="secondary"
          width="180px"
          fill={isMobile}
          onClick={handleDismiss}
        >
          {t('Dismiss')}
        </AppButton>
      </ButtonResponsiveWrapper>
    </Banner>
  );
};

export default BeneficiaryBanner;
